// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.86.2/styles/" + (chunkId === 225 ? "videojs" : chunkId) + ".chunk.css?" + {"225":"0be66fc79fd39f8af164","753":"353faa143a2edd9cbb97"}[chunkId] + "";
};